export const comments_4322234 = {"data":{"data":[],"links":{}}}